import React, { Component } from 'react'
import DataTablesCreateAux from "./DataTablesCreateAux";

const headers = [
    { title: 'Código' },
    { title: 'Descripción' }
];

class ClaveProdModal extends Component {

    componentDidMount() {

    }

    CloseThisModal = () => {
        const { CloseClaveProdModal } = this.props
        CloseClaveProdModal();
    }


    ChangeSearchClave = (value) => {
        const { SearchModalModel, RefreshSearchModalModel } = this.props
        SearchModalModel.Clave = value;
        SearchModalModel.Description = '';
        RefreshSearchModalModel(SearchModalModel);
    }

    ChangeSearchDescription = (value) => {
        const { SearchModalModel, RefreshSearchModalModel } = this.props
        SearchModalModel.Description = value;
        SearchModalModel.Clave = '';
        RefreshSearchModalModel(SearchModalModel);
    }


    render() {
        const { data, SearchModalModel, SearchBySearchModel, SelectClaveProd, SAPSearch } = this.props;
        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll" role="dialog" id="claveProdSATModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open" role="document" >
                    <div className="modal-content">

                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">{ !SAPSearch ? 'Catalogo del SAT' : 'Catalogo de artículos'}</h4>
                            <button type="button" className="close" onClick={this.CloseThisModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body" >


                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Clave</span>
                                        </div>
                                        <input type="text" className="form-control" id="txtPartner"
                                            onKeyPress={(eve) => {
                                                if (eve.key === 'Enter') {
                                                    SearchBySearchModel();
                                                }
                                            }}
                                            onChange={(event) => this.ChangeSearchClave(event.target.value)}
                                            value={SearchModalModel?.Clave ?? ''}
                                        />
                                        <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={() => SearchBySearchModel()}>
                                            <i className="fa fa-search fa-lg" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Descripción</span>
                                        </div>
                                        <input type="text" className="form-control" id="txtPartner"
                                            onKeyPress={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    SearchBySearchModel();
                                                }
                                            }}
                                            onChange={(event) => this.ChangeSearchDescription(event.target.value)}
                                            value={SearchModalModel?.Description ?? ''}
                                        />

                                        <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={() => SearchBySearchModel()}>
                                            <i className="fa fa-search fa-lg" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" >
                                            <table className="table response" style={{ marginBottom: 0, height: 570, maxHeight: 570 }}>
                                                <tbody>
                                                    <DataTablesCreateAux
                                                        data={data}
                                                        headers={headers}
                                                        view={"claveProdSAT"}
                                                        action={SelectClaveProd}
                                                        showStock={false}
                                                    />
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.CloseThisModal}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ClaveProdModal